window.keywordSearch = function keywordSearch() {

    $('.js_keywordSearchToggleBtn').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('.js_keywordSearchWrap').fadeToggle();

        // empty autocomplete search on open / close, forces a retype
        $('#keyword_search').val('');

        // close menu
        if ($('.js_menuFlyoutButton').hasClass('open')) {
            $('.js_menuFlyoutButton').removeClass('open');
            $('.mainNavigation').slideUp();
        }
    });

    // stop form submitting as autocomplete handles this
    $('.js_keywordSearchWrap form').on('submit', function (e) {
        e.preventDefault();
    });

    $('#keyword_search').autocomplete({
        source: function (request, response) {

            var csrf = '';
            var csrf_element = document.querySelector('meta[name="csrf"]');

            if (csrf_element) {
                csrf = csrf_element.getAttribute('content');
            }

            $.ajax({
                url: '/modules/Search/search_make_models_ajax.php',
                dataType: 'json',
                data: {
                    query: request.term,
                    csrf: csrf
                },
                beforeSend: function () {
                    $('#keywordLoader').fadeIn();
                },
                success: function (data) {
                    var r = [];
                    var models = [];

                    var empty_result = [
                        {
                            label: 'No results found for that search term. Click here to view our range of vehicles available.',
                            value: 'No results found for that search term. Click here to view our range of vehicles available.',
                            url: '/search'
                        }
                    ];

                    $('#keywordLoader').fadeOut();

                    var q = request.term.toLowerCase();

                    $.each(data, function (k, v) {
                        // console.log(v);
                        var make = v.name;

                        if (make.toLowerCase().indexOf(q) != -1) {
                            models.push({
                                label: make,
                                value: make,
                                url: v.url
                            });
                        }

                        $.each(v.models, function (o, i) {
                            var make_model = make + ' ' + i.name,
                                remove_dash = make_model.replace('-', ''),
                                add_space = make_model.replace('-', ' ');

                            if (make_model.toLowerCase().indexOf(q) != -1 || remove_dash.toLowerCase().indexOf(q) != -1 || add_space.toLowerCase().indexOf(q) != -1) {
                                models.push({
                                    label: make_model,
                                    value: make_model,
                                    url: i.url
                                });
                            }
                        });
                    });

                    if (!models.length) {
                        response(empty_result);
                    } else {
                        response(models);
                    }
                }
            });
        },
        minLength: 2,
        delay: 300,
        select: function (event, i) {
            event.preventDefault();
            var selected_result = i.item;

            // update input with value
            this.value = selected_result.label;

            // redirect to selected value
            window.location.href = selected_result.url;
        }
    });
}

$(document).ready(function () {
    'use strict';

    keywordSearch();

});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    if (windowWidth > 1020) {
        $('.js_keywordSearchWrap').removeAttr('style');
    }

}));
